import React, { useState, useEffect, useCallback } from 'react';

// import { useStatusSocket } from '../hooks/dadosSak';
import useDadosSakStore from '../stores/useDadosSakStore';
import { t } from 'i18next';

export default function ValidateAbas() {
  // const { setStatusSocket } = useStatusSocket();
  const [status, setStatus] = useState(false);

  const setStatusSocket = useDadosSakStore(
    (state) => state.setStatusSocketStore
  );

  const atualizarAbas = useCallback(
    (event) => {
      if (event.key !== 'abasAberta') return null;
      if (Number(event.newValue) !== Number(event.oldValue)) {
        setStatus(true);
        setStatusSocket(() => false);
      } else {
        localStorage.setItem('abasAberta', Date.now());
        setStatus(false);
        setStatusSocket(() => true);
      }
    },
    [setStatusSocket]
  );

  useEffect(() => {
    window.addEventListener('storage', (e) => atualizarAbas(e));
    localStorage.setItem('abasAberta', Date.now());
  }, [atualizarAbas]);

  return status ? (
    <div
      id="msgRandom"
      className="
        tw-flex tw-flex-col tw-justify-center tw-items-center tw-h-dvh
        tw-bg-chat-area [@media(prefers-color-scheme:dark)]:tw-bg-chat-area-dark
        tw-text-black [@media(prefers-color-scheme:dark)]:tw-text-white
      "
    >
      <div className="reload-app">
        <h2 className='tw-text-inherit'>
          {t(
            'O Chat Sak encontra-se aberto em uma outra aba ou janela. Utilize o botão abaixo para voltar a utilizar nesta aba.'
          )}
        </h2>
        <div className="d-flex align-items-center justify-content-end">
          <button
            className="
              !tw-bg-west-bar [@media(prefers-color-scheme:dark)]:!tw-bg-west-bar-dark
              !tw-text-gray-500 [@media(prefers-color-scheme:dark)]:!tw-text-gray-400
            "
            onClick={() =>
              (window.location.href = 'https://app.sak.com.br/dashboard')
            }
          >
            {t('Sair')}
          </button>
          <button
            className="!tw-bg-indigo-600 !tw-text-white"
            onClick={() => window.location.reload()}
          >
            {t('Utilizar aqui')}
          </button>
        </div>
      </div>
    </div>
  ) : (
    true
  );
}
